// extracted by mini-css-extract-plugin
export default {"chip":"QuestChip_chip__KY5CQ","icon":"QuestChip_icon__87Km5","text":"QuestChip_text__Tsslc","sub":"QuestChip_sub__TYhLc","inline":"QuestChip_inline__8P1-u QuestChip_chip__KY5CQ"};